import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GridComponent, PageSettingsModel, SelectionSettingsModel, ToolbarItems } from '@syncfusion/ej2-angular-grids';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { AgmMap } from '@agm/core';
import { debounceTime, distinctUntilChanged, filter, finalize, switchMap, tap } from 'rxjs/operators';

import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

import { TenantService, CategoriaSuterhService, ComunidadService, ComunidadTipoContratoService, ConsorcioService, MenuFuncionService, TipoComunidadService } from '../../../../src/app/shared/services';
import { TipoGastoService, IncidenciaUsuarioService, UsuarioService, PedidoService, BancoService, MonedaService, MovimientoService } from '../../../../src/app/shared/services';

import { Banco, CategoriaSuterh, Comunidad, ComunidadTipoContrato, Consorcio, Cuenta, DialogConfirmRequest, DialogConfirmResponse, GetSaldoMonedaDto, GetSaldoRequestDto } from '../../../../src/app/shared/model';
import { IncidenciaUsuario, LocalStorageKeys, MenuFuncionCodes, Moneda, PedidoComunidadRolDto, SaveComunidadDto,SearchBancoRequest,SearchComunidadTipoContratoRequestDto } from '../../../../src/app/shared/model';
import { SearchIncidenciaUsuarioRequestDto, SearchMonedaRequest, SearchTipoComunidadRequest, SearchUsuariosRequestDto, TenantFeatureFlags, Usuario, UsuarioComunidadDto } from '../../../../src/app/shared/model';
import { SearchConsorcioRequest, SearchCategoriaSuterhRequest, TipoComunidad, TipoGasto, SearchTipoGastoRequest } from '../../../../src/app/shared/model';

import { DialogConfirmComponent } from '../../../../src/app/shared/components/modals/dialogConfirm.component';

@Component({
  selector: 'app-comunidadEdit',
  templateUrl: './comunidadEdit.component.html',
  styleUrls: ['./comunidadEdit.component.scss']
})

export class ComunidadEditComponent implements OnInit {
  //MAPA
  lat: number;
  lng: number;
  zoom: number;
  mapTypeId: string;
  usuarioMarker: any;
  usuarioLocated: boolean;
  obraMarker: any;
  obraLocated: boolean;
  @ViewChild(AgmMap) map: AgmMap;
  @ViewChild('mapContainer', {static: false}) gmap: ElementRef;
 /*  map: google.maps.Map; */
  //********** */

  @ViewChild('grid')
  public grid: GridComponent;
  @ViewChild('usuarioGrid')
  public usuarioGrid: GridComponent;
  @ViewChild('seguroGrid')
  public seguroGrid: GridComponent;
  @ViewChild('cuentasGrid')
  public cuentasGrid: GridComponent;
  @ViewChild('tiposGastosGrid')
  public tiposGastosGrid: GridComponent;
  
  formGroup: FormGroup;
  contactoEmergenciaFormGroup: FormGroup;
  tiposGastosFormGroup: FormGroup;
  formFileGroup: FormGroup;
  formSeguroGroup: FormGroup;
  formUsuarioGroup: FormGroup;
  cuentaBancariaFormGroup: FormGroup;

  isValidating: boolean = false;
  isSearching: boolean = false;
  isSaving: boolean = false;
  isDeleting: boolean = false;
  isTipoSearching: boolean = false;
  isAttachmentSearching: boolean = false;
  isNumerosEmergenciaSearching: boolean = false;
  isComunidadTiposGastosSearching: boolean = false;
  isTiposGastosSearching: boolean = false;
  isFileAttaching: boolean = false;
  isFileDeleting: boolean = false;
  isComunidadTipoContratoSearching: boolean = false;
  isSeguroFileAttaching: boolean = false;

  canEdit: boolean = false;
  canDelete: boolean = false;
  canAdd: boolean = false;
  canView: boolean = false;
  canEditCuenta: boolean = false;
  canDeleteCuenta: boolean = false;
  canAddCuenta: boolean = false;
  canViewCuenta: boolean = false;
  canViewPuntoEq: boolean = false;

  isConsorcioSearching: boolean = false;
  isTipoComunidadSearching: boolean = false;
  isCategoriaSuterhSearching: boolean = false;
  isSegurosSearching: boolean = false;
  canViewIncidencias: boolean = false;
  canViewSaldos: boolean = false;
  isIncidenciasSearching: boolean = false;
  isPedidoComunidadRolSearching: boolean = false;
  isUsuarioSearching: boolean = false;
  isUsuarioAutocompleteSearching: boolean = false;
  isMonedaSearching: boolean = false;
  isBancoSearching: boolean = false;
  isCuentasSearching: boolean = false;
  isSaldosSearching: boolean = false;

  canUserEdit: boolean = false;
  canUserView: boolean = false;

  msgError: string = "";
  item: Comunidad;
  tiposGastosString: string = "";
  comunidadId: number;

  pedidoComunidadRolList: PedidoComunidadRolDto[];
  incidenciasList: IncidenciaUsuario[];
  consorcioList: Consorcio[];
  tipoComunidadList: TipoComunidad[];
  categoriaSuterhList: CategoriaSuterh[];
  monedaList: Moneda[] = [];
  bancoList: Banco[] = [];
  tiposGastosList: TipoGasto[];
  saldosList: GetSaldoMonedaDto[];

  newFileDescripcion: string = "";

  comunidadImageBase64: string | ArrayBuffer | null;
  comunidadImageExtension: string = "";
  comunidadTipoContratoList: ComunidadTipoContrato[];

  filteredUsuariosList: Usuario[];
  
  tenantFeatureFlags: TenantFeatureFlags;

  public selectionOptions: SelectionSettingsModel;
  public pageSizes: number[];
  public toolbarOptions: ToolbarItems[];
  public pageSettings: PageSettingsModel;

  constructor (
    private formBuilder: FormBuilder,
    private location: Location,
    public dialog: MatDialog,
    private sharedFunctions: SharedFunctions,
    private route: ActivatedRoute,
    private router: Router,
    private menuService: MenuFuncionService,
    private tipoGastoService: TipoGastoService,
    private consorcioService: ConsorcioService,
    private tipoComunidadService: TipoComunidadService,
    private categoriaSuterhService: CategoriaSuterhService,
    private comunidadService: ComunidadService,
    private comunidadTipoContratoService: ComunidadTipoContratoService,
    private usuarioService: UsuarioService,
    private monedaService: MonedaService,
    private bancoService: BancoService,
    private pedidoService: PedidoService,
    private incidenciaUsuarioService: IncidenciaUsuarioService,
    private movimientoService: MovimientoService,
    private tenantService: TenantService
  ) {
      this.lat = -38;
      this.lng = -63;
      this.zoom = 6;
      this.mapTypeId = 'roadmap';
      this.usuarioLocated = false;
      this.obraLocated = false;
  }

  ngOnInit(): void {
    this.isValidating = true;
    this.menuService.checkMenuPadre(MenuFuncionCodes.COMUNIDAD).subscribe(data => {
      if (data != null && data.Success && data?.Result) {
        this.tenantService.getTenantFeatureFlagsById(this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.TenantId)).subscribe(dataTenant => {
          this.isValidating = false;
          if (dataTenant != null && dataTenant.Success) {
            this.tenantFeatureFlags = dataTenant.Result;
            this.canEdit = data.Result.some(x => x == MenuFuncionCodes.COMUNIDAD_EDIT);
            this.canAdd = data.Result.some(x => x == MenuFuncionCodes.COMUNIDAD_ADD);
            this.canView = data.Result.some(x => x == MenuFuncionCodes.COMUNIDAD_LIST);
            this.canDelete = data.Result.some(x => x == MenuFuncionCodes.COMUNIDAD_DELETE);
            this.loadView();
          }
        },
        (err: HttpErrorResponse) => {
          this.isValidating = false;
          this.sharedFunctions.handleError(err, true);
        })
      }
      else {
        this.isValidating = false;
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.onCancel();
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });
  }

  loadView() {
    this.buildForm();
    this.buildContactoEmergenciaForm();
    this.buildFileForm();
    this.buildUsuarioForm();
    this.buildCuentaForm();
    this.buildSeguroForm();

    this.getTipos();
    
    this.puedeVerCuentas();
    this.puedeVerIncidencias();
    this.puedeVerSaldos();
    this.puedeVerUsuarios();
    this.getUsuario();

    this.getBancos();
    this.getMonedas();

    if (this.tenantFeatureFlags?.HabilitarGestionConsorcio) {
      this.getConsorcios();
      this.getCategoriasSuterh();
    }
    
    if (this.tenantFeatureFlags?.HabilitarControlGastos) {
      this.buildTiposGastosForm();
      this.getTiposGastos();
    }

    if (this.tenantFeatureFlags?.HabilitarGestionObra) {
      this.getTipoContrato();
    }

    if (this.tenantFeatureFlags?.HabilitarControlPedidos) {
      this.getPedidoComunidadRoles();
    }

    if (this.tenantFeatureFlags?.HabilitarControlCaja) {
      this.getMovimientoPermiso();
    }

    this.loadEntity();
  }

  getMovimientoPermiso() {
    this.menuService.checkMenuPadre(MenuFuncionCodes.MOVIMIENTO).subscribe(data => {
      if (data != null && data.Success && data.Result != null && data.Result.length > 0)
        this.canViewPuntoEq = true;
    },
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err);
    });
  }

  buildForm() {
    var cId = this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.ConsorcioId);
    if (cId != null && cId.length > 0 && cId > 0)
      cId = Number(cId);

    this.formGroup = this.formBuilder.group({
      'Nombre': [null, [Validators.required, Validators.maxLength(200)]],
      'TipoComunidadId': [null, Validators.required],
      'CantidadPisos': [null],
      'FechaConstruccion': [null],
      'Direccion': [null],
      'CodigoPostal': [null],
      'Observaciones': [null, Validators.maxLength(300)],
      'Activo': [true, Validators.required],
      
      'CategoriaSuterhId': [null],
      'ClaveSuterh': [null],
      'ConsorcioId': [cId],

      'ContratistaPrincipal': [null],
      'EjecutivaObra': [null],
      'M2Obra': [null],
      'TipoContratoId': [null],
      'DirectorObra': [null],
      'EstudioProyectista':[null],
      'EstudioCalculista': [null],
      'RepresentanteTecnico': [null],
      'PuntoEquilibrio': [null]
    });

    if (this.tenantFeatureFlags?.HabilitarGestionConsorcio) {
      const consorcioIdControl = this.formGroup.get('ConsorcioId');
      if (consorcioIdControl != null) {
        consorcioIdControl.setValidators([Validators.required]);
        consorcioIdControl.updateValueAndValidity();
      }

      const claveSuterhControl = this.formGroup.get('ClaveSuterh');
      if (claveSuterhControl != null) {
        claveSuterhControl.setValidators([Validators.maxLength(200)]);
        claveSuterhControl.updateValueAndValidity();
      }
    }

    if (this.tenantFeatureFlags?.HabilitarGestionObra) {
      const contratistaPrincipalControl = this.formGroup.get('ContratistaPrincipal');
      if (contratistaPrincipalControl != null) {
        contratistaPrincipalControl.setValidators([Validators.required, Validators.maxLength(200)]);
        contratistaPrincipalControl.updateValueAndValidity();
      }

      const ejecutivaObraControl = this.formGroup.get('EjecutivaObra');
      if (ejecutivaObraControl != null) {
        ejecutivaObraControl.setValidators([Validators.required, Validators.maxLength(200)]);
        ejecutivaObraControl.updateValueAndValidity();
      }

      const m2ObraControl = this.formGroup.get('M2Obra');
      if (m2ObraControl != null) {
        m2ObraControl.setValidators([Validators.required]);
        m2ObraControl.updateValueAndValidity();
      }

      const tipoContratoIdControl = this.formGroup.get('TipoContratoId');
      if (tipoContratoIdControl != null) {
        tipoContratoIdControl.setValidators([Validators.required]);
        tipoContratoIdControl.updateValueAndValidity();
      }

      const directorObraControl = this.formGroup.get('DirectorObra');
      if (directorObraControl != null) {
        directorObraControl.setValidators([Validators.required, Validators.maxLength(200)]);
        directorObraControl.updateValueAndValidity();
      }

      const estudioProyectistaControl = this.formGroup.get('EstudioProyectista');
      if (estudioProyectistaControl != null) {
        estudioProyectistaControl.setValidators([Validators.required, Validators.maxLength(200)]);
        estudioProyectistaControl.updateValueAndValidity();
      }

      const estudioCalculistaControl = this.formGroup.get('EstudioCalculista');
      if (estudioCalculistaControl != null) {
        estudioCalculistaControl.setValidators([Validators.required, Validators.maxLength(200)]);
        estudioCalculistaControl.updateValueAndValidity();
      }

      const representanteTecnicoControl = this.formGroup.get('RepresentanteTecnico');
      if (representanteTecnicoControl != null) {
        representanteTecnicoControl.setValidators([Validators.required, Validators.maxLength(200)]);
        representanteTecnicoControl.updateValueAndValidity();
      }
    }
  }

  buildFileForm() {
    this.formFileGroup = this.formBuilder.group({
      'Descripcion': [null, [Validators.required, Validators.maxLength(150)]]      
    });
  }

  buildUsuarioForm() {
    this.formUsuarioGroup = this.formBuilder.group({
      'Usuario': [null, [Validators.required]],
      'PedidoComunidadRol': [null],
      'grid-index': [null]
    });

    //No necesariamente hace falta que deba seleccionar un rol para pedidos. No todos los usuarios participan en eso
    // if (this.tenantFeatureFlags?.HabilitarControlPedidos) {
    //   const pedidoComunidadRolControl = this.formUsuarioGroup.get('PedidoComunidadRol');

    //   pedidoComunidadRolControl.setValidators([Validators.required]);
    //   pedidoComunidadRolControl.updateValueAndValidity();
    // }
  }

  buildCuentaForm(){
    this.cuentaBancariaFormGroup = this.formBuilder.group({
      'Id': [0],
      'BancoId': [null, Validators.required],
      'MonedaId': [null, Validators.required],
      'ClaveBancaria': [null, [Validators.required, Validators.maxLength(100)]],
      'Alias': [null, [Validators.required, Validators.maxLength(100)]],
      'Titular': [null, [Validators.maxLength(100)]],
      'NumeroCuenta': [null, [Validators.maxLength(100)]],
      'Activo': [true],
      'grid-index': [null]
    });
  }

  buildSeguroForm() {
    this.formSeguroGroup = this.formBuilder.group({
      'Descripcion': [null, [Validators.required, Validators.maxLength(150)]],
      'VigenciaDesde': [null, [Validators.required]],
      'VigenciaHasta': [null, [Validators.required]],
      'AdjuntoUrl': [null, [Validators.required]],
      'NombreAdjunto': [null, [Validators.required]],
      'index': [null],
      'Id': [0]
    });
  }

  buildContactoEmergenciaForm() {
    this.contactoEmergenciaFormGroup = this.formBuilder.group({
      'Descripcion': [null, [Validators.required, Validators.maxLength(200)]],
      'NumeroContacto': [null, [Validators.required, Validators.maxLength(100)]]
    });
  }

  buildTiposGastosForm() {
    if (!this.tenantFeatureFlags?.HabilitarControlGastos)
      return false;

    this.tiposGastosFormGroup = this.formBuilder.group({
      'TipoGastoId': [null, Validators.required],
      'MostrarEnResumenExpensa': [true]
    });
  }

  puedeVerCuentas() {
    this.menuService.checkMenuPadre(MenuFuncionCodes.CUENTA).subscribe(data => {
      if (data != null && data.Success && data.Result != null)
        this.canEditCuenta = data.Result.some(x => x == MenuFuncionCodes.CUENTA_EDIT);
        this.canAddCuenta = data.Result.some(x => x == MenuFuncionCodes.CUENTA_ADD);
        this.canViewCuenta = data.Result.some(x => x == MenuFuncionCodes.CUENTA_LIST);
        this.canDeleteCuenta = data.Result.some(x => x == MenuFuncionCodes.CUENTA_DELETE);
    },
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err);
    });
  }

  getTipoContrato() {
    var r = new SearchComunidadTipoContratoRequestDto(null, null, true, "Nombre", null, null, true);
    this.isComunidadTipoContratoSearching = true;

    this.comunidadTipoContratoService.search(r).subscribe(data => {
      this.isComunidadTipoContratoSearching = false;
      this.comunidadTipoContratoList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isComunidadTipoContratoSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getPedidoComunidadRoles() {
    if (!this.tenantFeatureFlags?.HabilitarControlPedidos)
      return;

    this.isPedidoComunidadRolSearching = true;
    this.pedidoService.getPedidoComunidadRoles().subscribe(data => {
      this.isPedidoComunidadRolSearching = false;
      this.pedidoComunidadRolList = data?.Result;
    },
    (err: HttpErrorResponse) => {
      this.isPedidoComunidadRolSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getTipos() {
    var r = new SearchTipoComunidadRequest(null, null, true, "Nombre", null, null, null, true);
    this.isTipoComunidadSearching = true;

    this.tipoComunidadService.search(r).subscribe(data => {
      this.isTipoComunidadSearching = false;
      this.tipoComunidadList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isTipoComunidadSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getConsorcios() {
    if (!this.tenantFeatureFlags?.HabilitarGestionConsorcio)
      return false;
    
    var r = new SearchConsorcioRequest(null, null, true, "Nombre", null, null, null, null, null, true);
    this.isConsorcioSearching = true;

    this.consorcioService.search(r).subscribe(data => {
      this.isConsorcioSearching = false;
      if (data != null)
        this.consorcioList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isConsorcioSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getCategoriasSuterh() {
    if (!this.tenantFeatureFlags?.HabilitarGestionConsorcio)
      return false;

    var r = new SearchCategoriaSuterhRequest(null, null, true, "Nombre", null, null, null, true);
    this.isCategoriaSuterhSearching = true;

    this.categoriaSuterhService.search(r).subscribe(data => {
      this.isCategoriaSuterhSearching = false;
      if (data != null)
        this.categoriaSuterhList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isCategoriaSuterhSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getCuentas(id: number) {
    // var r = new SearchCuentaRequest(null, null, true, "Codigo", null, null, null, null, null, null, null, null, id, null, null, null, true, null, null, null);
    // this.isCuentasSearching = true;

    // this.cuentaService.search(r).subscribe(data => {
    //   this.isCuentasSearching = false;
    //   // console.log(data);
    //   if (this.item != null)
    //     this.item.Cuentas = data?.result;
    // },
    // (err: HttpErrorResponse) => {
    //   this.isCuentasSearching = false;
    //   this.sharedFunctions.handleError(err);
    // });
  }

  getTiposGastos() {
    if (!this.tenantFeatureFlags?.HabilitarControlGastos)
      return false;

    var r = new SearchTipoGastoRequest(null, null, true, "Nombre", null, null, null, null, true);
    this.isTiposGastosSearching = true;

    this.tipoGastoService.search(r).subscribe(data => {
      this.isTiposGastosSearching = false;
      if (data != null)
        this.tiposGastosList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isTiposGastosSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getBancos() {
    if (!this.tenantFeatureFlags.HabilitarControlCaja)
      return false;

    this.bancoService.search(new SearchBancoRequest(null,null,null,null,null,null,null,true)).subscribe(data => {
      this.isBancoSearching = true;
      if (data != null && data.result) {
        this.isBancoSearching = false;
        this.bancoList = data?.result;
      }
    },
    (err: HttpErrorResponse) => {
      this.isBancoSearching = false;
      this.sharedFunctions.handleError(err);
    })
  }

  getMonedas() {
    if (!this.tenantFeatureFlags.HabilitarControlCaja)
      return false;

    var r = new SearchMonedaRequest(null, null, true, "Codigo", null, null, null, true);
    this.isMonedaSearching = true;

    this.monedaService.search(r).subscribe(data => {
        this.isMonedaSearching = false;
        this.monedaList = data?.result;
    },
    (err: HttpErrorResponse) => {
        this.isMonedaSearching = false;
        this.sharedFunctions.handleError(err);
    });
  } 

  getIncidencias(id: number) {
    var r = new SearchIncidenciaUsuarioRequestDto(null, null, true, "FechaUltimoMensaje", null, null, null, null, null, null, id, null, null, null, null, null, null, null, null, null);
    this.isIncidenciasSearching = true;

    this.incidenciaUsuarioService.search(r).subscribe(data => {
      this.isIncidenciasSearching = false;
      this.incidenciasList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isIncidenciasSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  isProcessing() {
    return (this.isSearching || this.isSaving || this.isDeleting);
  }

  clearDate(formFieldName: string) {
    if (formFieldName != null && formFieldName.length > 0) {
      if (this.formGroup.get(formFieldName) != null && this.formGroup.get(formFieldName)?.value)
        this.formGroup.get(formFieldName)?.setValue(null);
    }
  }

  puedeVerUsuarios() {
    this.menuService.checkMenuPadre(MenuFuncionCodes.USER).subscribe(data => {
      if (data != null && data.Success && data?.Result != null) {
        this.canUserEdit = data.Result.some(x => x == MenuFuncionCodes.USER_ADD || x == MenuFuncionCodes.USER_EDIT);
        this.canUserView = data.Result.length > 0;
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err);
    });
  }

  puedeVerIncidencias() {
    this.menuService.checkMenu(MenuFuncionCodes.INCIDENCIA_USUARIO_LIST).subscribe(data => {
      if (data != null && data.Success && data?.Result)
        this.canViewIncidencias = this.canViewIncidencias || data?.Result;
    },
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err);
    });

    this.menuService.checkMenu(MenuFuncionCodes.INCIDENCIA_USUARIO_LIST_BO).subscribe(data => {
      if (data != null && data.Success && data?.Result)
        this.canViewIncidencias = this.canViewIncidencias || data?.Result;
    },
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err);
    });
  }

  puedeVerSaldos() {
    if (!this.tenantFeatureFlags?.HabilitarControlCaja) {
      this.canViewSaldos = false;
      return false;
    }

    this.menuService.checkMenuPadre(MenuFuncionCodes.MOVIMIENTO).subscribe(data => {
      if (data != null && data.Success && data?.Result)
        this.canViewSaldos = this.canViewSaldos || (data?.Result != null && data?.Result.length > 0);
    },
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err);
    });
  }

  loadEntity() {
    this.route.params.subscribe(params => {
      if (params['id'] != null && params['id'] != '0') {
        this.comunidadId = Number(params['id']);

        if (this.comunidadId > 0) {
          if (this.canView || this.canEdit) {
            this.isSearching = true;
            this.comunidadService.get(this.comunidadId).subscribe(data => {
              this.isSearching = false;
              if (data != null && data.Success) {
                this.item = data.Result;

                if (this.item != null && this.item.Id > 0) {
                  this.loadAttachments(this.item.Id);
                  this.loadSeguros(this.item.Id);
                  this.loadNumerosEmergencia(this.item.Id);
                  this.loadTiposGastos(this.item.Id);
                  this.loadUsuarios(this.item.Id);
                  this.loadObraPosition(this.item);
                  this.getIncidencias(this.item.Id);
                  this.getCuentas(this.item.Id);
                  this.getSaldos(this.item.Id);

                  if (this.canEdit) {
                    this.formGroup.patchValue(this.item);
                  }
                  else {
                    this.tiposGastosString = this.item.TiposGastos?.map(item => item?.TipoGasto)?.join(", ");
                  }
                }
                else
                  this.msgError = "No se encontró el item seleccionado.";
              }
              else
                this.msgError = "Ocurrió un error al intentar obtener los datos del item.";
            },
            (err: HttpErrorResponse) => {
              this.isSearching = false;
              this.sharedFunctions.handleError(err, true);
            })
          } 
          else {
            this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
            this.onCancel();
          }
        } else
          this.msgError = "Item no válido.";
      } 
      else {
        if (this.canAdd) {
          this.item = new Comunidad(0, null, 0, null, null, null, true, null, null, null, null, null, [], [], [], [], [], [], [], null);
          // this.formGroup.patchValue(this.item);
        } 
        else {
          this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
          this.onCancel();
        }
      }
    });
  }

  getErrorTipoComunidad() {
    return this.formGroup.get('TipoComunidadId')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorNombre() {
    var v = this.formGroup.get('Nombre');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 200 caracteres alcanzado';
    return '';
  }

  getErrorConsorcio() {
    return this.formGroup.get('ConsorcioId')?.hasError('required') ? 'El campo es obligatorio' :'';
  }

  getErrorObservaciones() {
    var v = this.formGroup.get('Observaciones');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 300 caracteres alcanzado';
    return '';
  }

  loadAttachments(id) {
    this.isAttachmentSearching = true;
    this.comunidadService.getAttachments(id).subscribe(data => {
      this.isAttachmentSearching = false;
      this.item.Adjuntos = data.Result;
    },
    (err: HttpErrorResponse) => {
      this.isAttachmentSearching = false;
      this.sharedFunctions.handleError(err);
    })
  }

  loadSeguros(id) {
    this.isSegurosSearching = true;
    this.comunidadService.getSeguros(id).subscribe(data => {
      this.isSegurosSearching = false;
      this.item.Seguros = data.Result;
    },
    (err: HttpErrorResponse) => {
      this.isSegurosSearching = false;
      this.sharedFunctions.handleError(err);
    })
  }

  loadNumerosEmergencia(id) {
    this.isNumerosEmergenciaSearching = true;
    this.comunidadService.getNumerosEmergencia(id).subscribe(data => {
      this.isNumerosEmergenciaSearching = false;
      this.item.NumerosEmergencia = data.Result;
    },
    (err: HttpErrorResponse) => {
      this.isNumerosEmergenciaSearching = false;
      this.sharedFunctions.handleError(err);
    })
  }

  loadUsuarios(id) {
    this.isUsuarioSearching = true;
    this.comunidadService.getUsuarios(id).subscribe(data => {
      this.isUsuarioSearching = false;
      this.item.Usuarios = data.Result;
    },
    (err: HttpErrorResponse) => {
      this.isUsuarioSearching = false;
      this.sharedFunctions.handleError(err);
    })
  }

  loadTiposGastos(id) {
    if (!this.tenantFeatureFlags?.HabilitarControlGastos)
      return false;

    this.isComunidadTiposGastosSearching = true;
    this.comunidadService.getTiposGasto(id).subscribe(data => {
      this.isComunidadTiposGastosSearching = false;
      this.item.TiposGastos = data.Result;

      if (this.item.TiposGastos != null) {
        this.tiposGastosString = this.item.TiposGastos?.map(item => item?.TipoGasto)?.join(", ");
      }
    },
    (err: HttpErrorResponse) => {
      this.isComunidadTiposGastosSearching = false;
      this.sharedFunctions.handleError(err);
    })
  }

  getSaldos(id) {
    var r = new GetSaldoRequestDto(null, null, id, null, null, null, null);
    this.isSaldosSearching = true;
    
    this.movimientoService.getSaldo(r).subscribe(data => {
      this.isSaldosSearching = false;
      if (data?.Success)
        this.saldosList = data.Result?.Saldos;
    },
    (err: HttpErrorResponse) => {
      this.isSaldosSearching = false;
      this.sharedFunctions.handleError(err);
    })
  }

  onCuentaSave() {
    if (this.cuentaBancariaFormGroup.invalid) {  
      this.sharedFunctions.showMessage("Formulario inválido. Por favor, complete todos los campos requeridos.", "Error");
      return;
    }
    
    var nuevaCuenta = new Cuenta(0, null, false, null, null, null, null, null, null, null, null, true, null, null, null, null, null, null, null, null, null, null);
    nuevaCuenta = { 
      ...this.cuentaBancariaFormGroup.getRawValue(),
      BancoNombre: this.bancoList.find(x => x.Id == this.cuentaBancariaFormGroup.get("BancoId")?.value)?.Nombre, 
      MonedaCodigo: this.monedaList.find(x => x.Id == this.cuentaBancariaFormGroup.get("MonedaId")?.value)?.Codigo, 
      ProveedorId: (this.item?.Id ?? 0)
    };

    if (this.item.Cuentas == null)
      this.item.Cuentas = [];

    var index = this.cuentaBancariaFormGroup.get("grid-index")?.value;
    if (index != null && index >= 0) {
      this.item.Cuentas[index] = nuevaCuenta;
    }
    else {
      var exists = this.item.Cuentas.some(f => f.Alias == nuevaCuenta.Alias || f.ClaveBancaria == nuevaCuenta.ClaveBancaria);
      if (exists) {
        this.sharedFunctions.showMessage("El alias o CBU/CVU ingresados ya existen para el proveedor", "Error");
        return false;
      }

      this.item.Cuentas.push(nuevaCuenta);
    }

    this.cuentaBancariaFormGroup.reset();
    this.cuentaBancariaFormGroup.controls['Id'].setValue(0);
    this.cuentaBancariaFormGroup.controls['Activo'].setValue(true);

    this.cuentasGrid?.refresh();
  }

  onCuentaView(data: any) {
    this.cuentaBancariaFormGroup.patchValue(data);
    this.cuentaBancariaFormGroup.get("grid-index")?.setValue(data.index);
  }

  onCuentaDelete(data: any) {
    if (this.item.Cuentas == null)
      this.item.Cuentas = [];

    if (data.index >= 0) {
      this.item.Cuentas.splice(data.index, 1);
      this.cuentasGrid?.refresh();
    }
  }

  onGuardar() {
    if (!this.formGroup.valid) {
      this.sharedFunctions.showMessage("Por favor complete todos los datos obligatorios para continuar", "Error");
      const formGroupcontrols = this.formGroup.controls;
      Object.keys(formGroupcontrols).forEach(controlName => formGroupcontrols[controlName].markAsTouched());
      return false;
    }

    var index = this.comunidadImageBase64?.toString()?.indexOf(",");
    var r = new SaveComunidadDto(0, null, 0, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, true);

    if (this.item.Adjuntos == null)
      this.item.Adjuntos = [];

    if (this.item.Seguros == null)
      this.item.Seguros = [];

    if (this.item.Usuarios == null)
      this.item.Usuarios = [];

    if (this.obraMarker == null)
      this.obraMarker = {
        lat: 0,
        lng: 0,
        draggable: true,
      }

    r = 
    {
      ...this.formGroup.value,
      ...
      {
        Id: (this.item?.Id ?? 0),
        FotoPerfilBase64: (index != null && index >= 0 ? this.comunidadImageBase64?.toString()?.substring(index + 1) : null),
        FotoPerfilExtension: this.comunidadImageExtension,
        LatitudMapa: this.obraMarker?.lat ?? 0,
        LongitudMapa: this.obraMarker?.lng ?? 0,
        Activo: (this.item?.Activo ?? true),
        Adjuntos: this.item?.Adjuntos,
        Seguros: this.item?.Seguros,
        Usuarios: this.item?.Usuarios,
        NumerosEmergencia: this.item?.NumerosEmergencia,
        TiposGastos: this.item?.TiposGastos,
        Cuentas: this.item?.Cuentas,
      }
    };

    this.isSaving = true;
    this.comunidadService.save(r).subscribe(data => {
      this.isSaving = false;
      if (data != null && data.Success && data.Result != null && data.Result.Id > 0) {
        this.sharedFunctions.showMessage("Se guardaron correctamente los datos!", "Operación Exitosa!");
        this.onCancel();
      }
      else
        this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
    },
    (err: HttpErrorResponse) => {
      this.isSaving = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  onCancel() {
    this.location.back();
  }

  onFileAttachedDelete(item: any) {
    if (item.Id > 0)
      this.onExistingFileAttachedDelete(item);
    else
      this.onNewFileAttachedDelete(item);
  }

  onExistingFileAttachedDelete(item: any) {
    if (this.item.Adjuntos != null && this.item.Adjuntos.length > 0) {
      var index = this.item.Adjuntos.findIndex(f => f.Id == item.Id);

      if (index >= 0)
        this.item.Adjuntos.splice(index, 1);
    }
  }

  onNewFileAttachedDelete(item: any) {
    if (this.item.Adjuntos != null && this.item.Adjuntos.length > 0) {
      var index = this.item.Adjuntos.findIndex(f => f.NombreDocumento == item.NombreDocumento);

      if (index >= 0)
        this.item.Adjuntos.splice(index, 1);
    }
  }

  onNewFileAttach(event: any) {
    if (event?.target?.files != null && event.target.files.length > 0) {
      var fileList = event.target.files;

      if (this.item.Adjuntos == null)
        this.item.Adjuntos = [];

      for (var i=0; i<fileList.length; i++) {
        if (this.item.Adjuntos.find(f => f.NombreDocumento == fileList[i].name)) {
          setTimeout(() => {
            this.sharedFunctions.showMessage("Ya existe un archivo con ese nombre. Por favor modifique el nombre del archivo o elimine el ya adjuntado", "Error");
          }, 100);
          return false;
        }
      }

      if (fileList != null && fileList.length > 0) {
        this.isFileAttaching = true;
        this.comunidadService.uploadAttachTemp(fileList).subscribe(data => {
          this.isFileAttaching = false;
          if (data != null && data.Success && data.Result != null && data.Result.Archivos != null && data.Result.Archivos.length > 0) {
            for (let i=0; i<data.Result.Archivos.length; i++) {
              if (data.Result.Archivos[i] != null) {
                data.Result.Archivos[i].Descripcion = this.newFileDescripcion;
                this.item.Adjuntos.push(data.Result.Archivos[i]);
                this.newFileDescripcion = "";
              }
            }
          }
          else
            this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error intentando subir los archivos", "Error");
        },
        (err: HttpErrorResponse) => {
          this.isFileAttaching = false;
          this.sharedFunctions.handleError(err, true);
        })
      }
    }
  }

  getErrorDescripcion() {
    var v = this.contactoEmergenciaFormGroup.get('Descripcion');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 200 caracteres alcanzado';
    return '';
  }

  getErrorNumeroContacto() {
    var v = this.contactoEmergenciaFormGroup.get('NumeroContacto');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorAdjuntoDescripcion() {
    var v = this.formFileGroup.get('Descripcion');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 150 caracteres alcanzado';
    return '';
  }

  getErrorCategoriaSuterhId() {
    return this.formGroup.get('CategoriaSuterhId')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorClaveSuterh() {
    return this.formGroup.get('ClaveSuterh')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorTipoGastoId() {
    return this.tiposGastosFormGroup.get('TipoGastoId')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  onNroEmergenciaAdd() {
    if (!this.contactoEmergenciaFormGroup.valid) {
      this.sharedFunctions.showMessage("Por favor complete todos los datos obligatorios para continuar", "Error");
      return false;
    }

    if (this.item.NumerosEmergencia == null)
      this.item.NumerosEmergencia = [];

    this.item.NumerosEmergencia.push(this.contactoEmergenciaFormGroup.getRawValue());
    this.grid.refresh();

    this.buildContactoEmergenciaForm();
  }

  onNroEmergenciaDelete(item: any) {
    if (item != null && item.index >= 0) {
      if (this.item.NumerosEmergencia == null)
        this.item.NumerosEmergencia = [];

      this.item.NumerosEmergencia.splice(item.index, 1);
      this.grid.refresh();
    }
  }

  onUsuarioAdd() {
    if (!this.formUsuarioGroup.valid) {
      this.sharedFunctions.showMessage("Por favor complete todos los datos obligatorios para continuar", "Error");
      return false;
    }
    
    if (this.formUsuarioGroup.get("Usuario")?.value?.Id == null || this.formUsuarioGroup.get("Usuario")?.value?.Id <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar un usuario del listado de usuarios", "Error");
      return false;
    }

    if (this.item.Usuarios == null)
      this.item.Usuarios = [];

    if (this.item.Usuarios.some(f => f.UsuarioId == this.formUsuarioGroup.get("Usuario")?.value?.Id)) {
      this.sharedFunctions.showMessage("El usuario " + this.formUsuarioGroup.get("Usuario")?.value?.Login + " ya fue cargado", "Error");
      return false;
    }

    var r = new UsuarioComunidadDto(
      0,
      this.formUsuarioGroup.get("Usuario")?.value?.Id, 
      this.formUsuarioGroup.get("Usuario")?.value?.Login, 
      this.item?.Id, 
      this.item.Nombre, 
      (this.tenantFeatureFlags?.HabilitarControlPedidos ? this.formUsuarioGroup.get("PedidoComunidadRol")?.value?.Id : null), 
      (this.tenantFeatureFlags?.HabilitarControlPedidos ? this.formUsuarioGroup.get("PedidoComunidadRol")?.value?.Nombre : null), 
      0
    );

    var index = this.formUsuarioGroup.get("grid-index")?.value;
    if (index != null && index >= 0)
      this.item.Usuarios[index] = r;
    else
      this.item.Usuarios.push(r);

    this.usuarioGrid.refresh();
    this.formUsuarioGroup.reset();
    this.filteredUsuariosList = [];
  }

  onUsuarioDelete(item: any) {
    if (item != null && item.index >= 0) {
      if (this.item.Usuarios == null)
        this.item.Usuarios = [];

      this.item.Usuarios.splice(item.index, 1);
      this.usuarioGrid.refresh();
    }
  }

  getUsuario() {
    this.formUsuarioGroup.get("Usuario")?.valueChanges
      .pipe(
        filter(res => {
            return res && res !== null && res.length >= 3
        }),
        distinctUntilChanged(),
        debounceTime(1000),
        tap(() => {
            this.filteredUsuariosList = [];
            this.isUsuarioAutocompleteSearching = true;
        }),
        switchMap(value => this.usuarioService.search(new SearchUsuariosRequestDto(50, null, true, "Login", value, null, null, null, null, null, null, null, null, true, null))
          .pipe(
            finalize(() => {
              this.isUsuarioAutocompleteSearching = false;
            }),
          )
        )
      )
      .subscribe((data: any) => {
        if (data != null && data.result != null)
          this.filteredUsuariosList = data.result;
        else
          this.filteredUsuariosList = [];
      });
  }

  onTipoGastoAdd() {
    if (!this.tiposGastosFormGroup.valid) {
      this.sharedFunctions.showMessage("Por favor complete todos los datos obligatorios para continuar", "Error");
      return false;
    }

    if (this.item.TiposGastos == null)
      this.item.TiposGastos = [];

    var index = this.item.TiposGastos.findIndex(f => f.TipoGastoId == this.tiposGastosFormGroup.get('TipoGastoId')?.value);
    if (index >= 0) {
      this.item.TiposGastos[index] = { 
        ...this.tiposGastosFormGroup.getRawValue(), 
        ...{
          Id: this.item.TiposGastos[index].Id ?? 0,
          TipoGasto: this.tiposGastosList.find(f => f.Id == this.tiposGastosFormGroup.get('TipoGastoId')?.value)?.Nombre
        }
      };
    }
    else
      this.item.TiposGastos.push({ 
        ...this.tiposGastosFormGroup.getRawValue(), 
        ...{
          Id: 0,
          TipoGasto: this.tiposGastosList.find(f => f.Id == this.tiposGastosFormGroup.get('TipoGastoId')?.value)?.Nombre
        }
      });
    
    this.tiposGastosGrid.refresh();
    this.buildTiposGastosForm();
  }

  onTipoGastoDelete(item: any) {
    if (item != null && item.index >= 0) {
      if (this.item.TiposGastos == null)
        this.item.TiposGastos = [];

      this.item.TiposGastos.splice(item.index, 1);
      this.tiposGastosGrid.refresh();
    }
  }

  //#region FORM ERRORS
  getErrorContratistaPrincipal(){
    var v = this.formGroup.get('ContratistaPrincipal');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('ContratistaPrincipal'))
      return 'Límite de 200 caracteres alcanzado';
    return '';
  }

  getErrorEjecutivaObra(){
    var v = this.formGroup.get('EjecutivaObra');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('ContratistaPrincipal'))
      return 'Límite de 200 caracteres alcanzado';
    return '';
  }

  getErrorDirectorObra(){
    var v = this.formGroup.get('DirectorObra');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('ContratistaPrincipal'))
      return 'Límite de 200 caracteres alcanzado';
    return '';
  }
  
  getErrorEstudioProyectista(){
    var v = this.formGroup.get('EstudioProyectista');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('ContratistaPrincipal'))
      return 'Límite de 200 caracteres alcanzado';
    return '';
  }
  
  getErrorEstudioCalculista(){
    var v = this.formGroup.get('EstudioCalculista');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('ContratistaPrincipal'))
      return 'Límite de 200 caracteres alcanzado';
    return '';
  }
  
  getErrorRepresentanteTecnico(){
    var v = this.formGroup.get('RepresentanteTecnico');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('ContratistaPrincipal'))
      return 'Límite de 200 caracteres alcanzado';
    return '';
  }

  getErrorM2Obra(){
    return this.formGroup.get('M2Obra')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorTipoContratoId(){
    return this.formGroup.get('TipoContratoId')?.hasError('required') ? 'El campo es obligatorio' : '';
  }
  //#endregion
  
  //#region IMAGEN PERFIL
  comunidadImageChanged() {
    return (this.comunidadImageBase64 != null);
  }

  convertFileToBase64(event) {
    this.comunidadImageBase64 = null;
    const file = event.target.files[0];

    if (file != null) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        // this.backofficeImageBase64 = reader.result;
      };
      reader.onloadend = () => {
        this.comunidadImageBase64 = reader.result;
        this.comunidadImageExtension = (file?.name?.split('.')?.pop() ?? "");
        // console.log(reader.result);
      };
    }
  }
  //#endregion

  //#region UPLOAD SEGUROS
  onSeguroFileAttachedDelete(item: any) {
    if (item.Id > 0)
      this.onExistingSeguroFileAttachedDelete(item);
    else
      this.onNewSeguroFileAttachedDelete(item);
  }

  onExistingSeguroFileAttachedDelete(item: any) {
    if (this.item.Seguros != null && this.item.Seguros.length > 0) {
      var index = this.item.Seguros.findIndex(f => f.Id == item.Id);

      if (index >= 0)
        this.item.Seguros.splice(index, 1);
    }
  }

  onNewSeguroFileAttachedDelete(item: any) {
    if (this.item.Seguros != null && this.item.Seguros.length > 0) {
      var index = this.item.Seguros.findIndex(f => f.NombreAdjunto == item.NombreAdjunto);

      if (index >= 0)
        this.item.Seguros.splice(index, 1);
    }
  }

  onNewSeguroFileAttach(event: any) {
    if (event?.target?.files != null && event.target.files.length > 0) {
      var fileList = event.target.files;

      if (this.item.Seguros == null)
        this.item.Seguros = [];

      for (var i=0; i<fileList.length; i++) {
        if (this.item.Seguros.find(f => f.Descripcion == fileList[i].name)) {
          setTimeout(() => {
            this.sharedFunctions.showMessage("Ya existe un archivo con ese nombre. Por favor modifique el nombre del archivo o elimine el ya adjuntado", "Error");
          }, 100);
          return false;
        }
      }

      if (fileList != null && fileList.length > 0) {
        this.isSeguroFileAttaching = true;
        this.comunidadService.uploadSeguroAttachTemp(fileList).subscribe(data => {
          this.isSeguroFileAttaching = false;
          if (data != null && data.Success && data.Result != null && data.Result.Archivos != null && data.Result.Archivos.length > 0) {
            this.formSeguroGroup.get("AdjuntoUrl")?.setValue(data.Result.Archivos[0].AdjuntoUrl);
            this.formSeguroGroup.get("NombreAdjunto")?.setValue(data.Result.Archivos[0].NombreAdjunto);
          }
          else
            this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error intentando subir los archivos", "Error");
        },
        (err: HttpErrorResponse) => {
          this.isSeguroFileAttaching = false;
          this.sharedFunctions.handleError(err, true);
        })
      }
    }
  }

  clearSeguroDate(formFieldName: string) {
    if (formFieldName != null && formFieldName.length > 0) {
      if (this.formSeguroGroup.get(formFieldName) != null && this.formSeguroGroup.get(formFieldName)?.value)
        this.formSeguroGroup.get(formFieldName)?.setValue(null);
    }
  }

  getErrorVigenciaDesde(){
    return this.formSeguroGroup.get("VigenciaDesde")?.hasError("required") ? 'El campo es obligatorio' : '';
  }

  getErrorVigenciaHasta(){
    return this.formSeguroGroup.get("VigenciaHasta")?.hasError("required") ? 'El campo es obligatorio' : '';
  }

  getErrorSeguroDescripcion(){
    return this.formSeguroGroup.get("Descripcion")?.hasError("required") ? 'El campo es obligatorio' : '';
  }

  onSeguroView(data: any) {
    if (data == null) {
      this.sharedFunctions.showMessage("Debe seleccionar un item para continuar", "Error");
      return false;
    }

    this.formSeguroGroup.patchValue(data);
  }

  onSeguroAdd() {
    if(!this.formSeguroGroup.valid) {
      this.sharedFunctions.showMessage("Por favor complete todos los datos obligatorios para continuar", "Error");
      const formGroupcontrols = this.formSeguroGroup.controls;
      Object.keys(formGroupcontrols).forEach(controlName => formGroupcontrols[controlName].markAsTouched());
      return false;
    }

    if (this.item.Seguros == null)
      this.item.Seguros = [];

    var index = this.formSeguroGroup.get("index")?.value;
    if (index != null && index >= 0)
      this.item.Seguros[index] = this.formSeguroGroup.getRawValue();
    else
      this.item.Seguros.push(this.formSeguroGroup.getRawValue());
    this.seguroGrid.refresh();

    this.buildSeguroForm();
  }

  onSeguroDelete(item: any) {
    if (item != null && item.index >= 0) {
      if (this.item.Seguros == null)
        this.item.Seguros = [];

      this.item.Seguros.splice(item.index, 1);
      this.seguroGrid.refresh();
    }
  }
  //#endregion

  //#region EMPLEADOS ASOCIADOS

  displayUsuarios(usuario: any): string {
    return usuario && usuario?.Nombre || usuario?.Apellido ? (usuario.Apellido + ", " + usuario.Nombre).toUpperCase() + " - " + usuario.Login : '';
  }

  //#endregion

  //#region MAPA
  loadObraPosition(item){
    if(item.LatitudMapa == undefined || item.LongitudMapa == undefined || item.LatitudMapa == 0 || item.LongitudMapa == 0){
      return false;
    }
    this.lat = item.LatitudMapa;
    this.lng = item.LongitudMapa;
    this.zoom = 10;
    this.obraMarker = {
      lat: item.LatitudMapa,
      lng: item.LongitudMapa,
      draggable: false,
    }
    this.obraLocated = true;
  }

  getObraPosition() {
    if(this.obraMarker.lat == 0 || this.obraMarker.lng == 0){
      this.sharedFunctions.showMessage("La obra no tiene una ubicación especificada", "Error");
      return false;
    }
    this.lat = this.obraMarker.lat;
    this.lng = this.obraMarker.lng;
    this.zoom = 10;
  }

  deleteObraPosition(){
    this.obraMarker.lat = 0;
    this.obraMarker.lng = 0;
    this.obraLocated = false;
  }

  getCurrentPosition(){
    navigator.geolocation.getCurrentPosition(position=> {
      this.usuarioMarker = {
        lat: position.coords.latitude,
        lng: position.coords.longitude,
        draggable: false,
      };
      this.lat = position.coords.latitude;
      this.lng = position.coords.longitude;
      this.usuarioLocated = true;
    });
    this.zoom = 10;
  }

  markObraPosition(e: any){
    this.obraMarker = {
      lat: e.coords.lat,
      lng: e.coords.lng,
      draggable: true,
    }
    this.obraLocated = true;
  }

  onMarkerDragEnd(e: any) {
    this.obraMarker = {
      lat: e.coords.lat,
      lng: e.coords.lng,
      draggable: true,
    }
    this.obraLocated = true;
  }
  //#endregion

  onDelete() {
    if (!this.canDelete) 
        return false;
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: new DialogConfirmRequest(null, "¿Está seguro que desea eliminar el tem?", null, null)
    });
    dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
        if (result != null && result.Accepted) {
            this.isDeleting = true;
            this.comunidadService.delete(this.item.Id).subscribe(data => {
                this.isDeleting = false;
                if (data != null && data.Success && data.Result) {
                    this.sharedFunctions.showMessage("Se eliminaron correctamente los datos!", "Operación Exitosa!");
                    this.onCancel();
                }
                else
                    this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
            },
            (err: HttpErrorResponse) => {
                this.isDeleting = false;
                this.sharedFunctions.handleError(err, true);
            })
        }
    });
  }

  viewIncidencia(id: number) {
    if (id == null || id <= 0) {
        this.sharedFunctions.showMessage("Debe seleccionar un incidente para continuar", "Error");
        return false;
    }

    this.router.navigate(['incidencia-usuario-edit', id]);
  }
}
